import PremiumLocked from 'components/Items/Lock'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

const Button = ({
  children,
  disabled,
  isLoading,
  className,
  isLocked,
  isLockedMessage,
  onClick,
  ...rest
}) => {
  const onClickProp = onClick

  const navigate = useNavigate()

  return (
    <button
      type="button"
      className={`${isLocked ? 'relative' : ''} p-2.5 rounded flex opacity-90 focus:outline-none items-center justify-center text-white text-sm font-bold
      ${className} disabled:opacity-50 disabled:cursor-not-allowed ${
        !disabled ? 'hover:brightness-95' : ''
      }`}
      disabled={disabled || isLoading}
      onClick={e => {
        if (isLocked) {
          Swal.fire({
            title: 'Cumpără un abonament',
            text: isLockedMessage,
            icon: 'error',
            timer: '4000',
            confirmButtonText: 'Cumpără abonament',
            confirmButtonColor: 'rgba(var(--primary))',
            showCloseButton: true,
            theme: 'dark',
          }).then(result => {
            if (result.isConfirmed) {
              navigate('/abonamente')
            }
          })
        } else {
          if (onClickProp) {
            onClickProp(e)
          }
        }
      }}
      {...rest}
    >
      {isLoading ? (
        <i className="fa fa-circle-o-notch fa-spin text-lg"></i>
      ) : (
        children
      )}
      {isLocked ? (
        <PremiumLocked
          message={false}
          lockStyle={{
            position: 'absolute',
            right: -5,
            top: -5,
            width: '20px',
            height: '15px',
            color: 'rgb(244, 196, 48)',
            zIndex: '101',
          }}
        />
      ) : null}
    </button>
  )
}

export default Button
